import "regenerator-runtime/runtime";
import Alpine from "alpinejs";
export var sectionBehavior = function sectionBehavior() {
  Alpine.data("sectionBehavior", function () {
    return {
      matchHeightSelectors: [],
      init: function init() {
        this.section = this.$el;
        // Array empty until functionality required for BP2
        this.matchHeightSelectors = [];
        this.matchHeights(this.matchHeightSelectors);
      },
      bindSectionResize: {
        "@resize.window.stop.debounce": function resizeWindowStopDebounce() {
          this.matchHeights(this.matchHeightSelectors);
        }
      },
      matchHeights: function matchHeights(matchHeightSelectors) {
        var _this = this;
        matchHeightSelectors.forEach(function (matchHeightSelector) {
          var elements = _this.getElements(matchHeightSelector);
          if (elements.length) {
            var tallestElementHeight = _this.getTallestElementHeight(elements);
            if (tallestElementHeight) {
              _this.setElementHeights(elements, tallestElementHeight);
            }
          }
        });
      },
      getElements: function getElements(selector) {
        return this.section.querySelectorAll(selector);
      },
      getTallestElementHeight: function getTallestElementHeight(elements) {
        var elemHeights = [];
        elements.forEach(function (el) {
          elemHeights.push(el.offsetHeight);
        });
        return Math.max.apply(Math, elemHeights);
      },
      setElementHeights: function setElementHeights(elements, height) {
        elements.forEach(function (el) {
          el.style.height = height + "px";
        });
      }
    };
  });
};